import axios from "axios";
import { api } from "./helper";
import store from "../../store/store";
import { v4 as uuidv4 } from "uuid";

export function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({ baseURL: api, withCredentials: false });
client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function GetMonthlyCases() {
  return client.post("Stats/GetMonthlyCases", prepareRequest({}));
}

function GetStageStats() {
  return client.post("Stats/GetStageStats", prepareRequest({}));
}

function GetInsTypeStats() {
  return client.post("Stats/GetInsTypeStats", prepareRequest({}));
}

export { GetMonthlyCases, GetStageStats, GetInsTypeStats };
